import { FunctionComponent } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Form } from "./formColumns";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc/client";
import { removeFromList } from "@trainrr/api-client";

interface DeleteFormAlertProps {
  form?: Form;
  onOpenChange: (open: boolean) => void;
  onDeleted?: () => void;
}

const DeleteFormAlert: FunctionComponent<DeleteFormAlertProps> = ({
  form,
  onOpenChange,
  onDeleted,
}) => {
  const utils = trpc.useUtils();
  const deleteFormMutation = trpc.forms.delete.useMutation();

  const deleteForm = async () => {
    if (!form) {
      return;
    }

    try {
      await deleteFormMutation.mutateAsync({ formId: form.id });
    } catch (error) {
      console.error(error);
      toast.error("Error deleting form");
      return;
    }

    const current = utils.forms.list.getData(undefined);
    if (!current) void utils.forms.list.invalidate();
    else
      utils.forms.list.setData(undefined, () =>
        removeFromList(current, form.id),
      );

    onOpenChange(false);
    onDeleted?.();
  };

  return (
    <AlertDialog open={form !== undefined} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {form?.name}?</AlertDialogTitle>
          <AlertDialogDescription>
            If this form has responses it will be archived and removed from
            assignments. Otherwise it will be deleted.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction variant={"destructive"} onClick={deleteForm}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteFormAlert;
